import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import { isSameDay, isFirstDayOfMonth, isLastDayOfMonth, addMonths, subMonths, addDays, subDays, differenceInDays, min, max, endOfMonth, isToday, startOfDay, endOfDay, endOfMinute } from 'date-fns';
import { ControlsRoot } from './styles';

const DateRangeControls = props => {
  const {
    rangeStart,
    rangeEnd,
    minDate,
    maxDate,
    setDateRange
  } = props;

  const disabledForward = isSameDay(new Date(maxDate), new Date(rangeEnd));
  const disabledBack = isSameDay(new Date(minDate), new Date(rangeStart));

  const handlePrevClick = useCallback(() => {
    const start = startOfDay(new Date(rangeStart));
    const end = endOfDay(new Date(rangeEnd));

    const isMonthFirstDay = isFirstDayOfMonth(start);
    const isMonthLastDay = isLastDayOfMonth(end);
    if (isMonthFirstDay && isMonthLastDay) {
      const newRangeStart = max([subMonths(start, 1), new Date(minDate)]);
      const newRangeEnd = min([endOfMonth(subMonths(end, 1)), new Date(maxDate)]);
      setDateRange(newRangeStart, newRangeEnd);
    } else {
      const diffDays = differenceInDays(end, start) + 1;
      const newRangeStart = max([subDays(start, diffDays), new Date(minDate)]);
      const newRangeEnd = min([subDays(end, diffDays), new Date(maxDate)]);
      setDateRange(newRangeStart, newRangeEnd);
    }
  }, [setDateRange, rangeStart, rangeEnd, maxDate, minDate]);

  const handleNextClick = useCallback(() => {
    const start = startOfDay(new Date(rangeStart));
    const endDate = new Date(rangeEnd);
    const end = isToday(endDate) ? endOfMinute(new Date()) : endOfDay(endDate);

    const isMonthFirstDay = isFirstDayOfMonth(start);
    const isMonthLastDay = isLastDayOfMonth(end);

    if (isMonthFirstDay && isMonthLastDay) {
      const newRangeStart = max([addMonths(start, 1), new Date(minDate)]);
      const newRangeEnd = min([endOfMonth(addMonths(end, 1)), new Date(maxDate)]);
      setDateRange(newRangeStart, newRangeEnd);
    } else {
      const diffDays = differenceInDays(end, start) + 1;
      const newRangeStart = max([addDays(start, diffDays), new Date(minDate)]);
      const newRangeEnd = min([addDays(end, diffDays), new Date(maxDate)]);
      setDateRange(newRangeStart, newRangeEnd);
    }
  }, [setDateRange, rangeStart, rangeEnd, maxDate, minDate]);

  const handleUpdateClick = useCallback(() => {
    const start = new Date(rangeStart);

    setDateRange(start, new Date());
  }, [setDateRange, rangeStart]);

  return (
    props.mode === 'update' ?
      <ControlsRoot>
        <Button onClick={handleUpdateClick} disabled={!isToday(new Date(rangeEnd))} variant="outlined"><UpdateRoundedIcon fill="currentColor" /></Button>
      </ControlsRoot> :
      <ControlsRoot>
        <Button onClick={handlePrevClick} disabled={disabledBack} variant="outlined"><NavigateBeforeRoundedIcon fill="currentColor" /></Button>
        <Button onClick={handleNextClick} disabled={disabledForward} variant="outlined"><NavigateNextRoundedIcon fill="currentColor" /></Button>
      </ControlsRoot>
  );
};

export default DateRangeControls;
